export default __webpack_public_path__ + "77a6fe0159971376fdbf703cff3fc0a5.svg";